import React, { useEffect, useState } from "react";

import useDisplay from "../../../hooks/useDisplay";
import PretendardText from "../../atoms/text/pretendardText";
import RightLabelCheckbox from "../../molecules/checkbox/rightLabelCheckbox";

const CheckboxForm = ({ data, setList, list }) => {
  const { isMobile } = useDisplay();
  const [checkboxValue, setCheckboxValue] = useState([]);
  const [checkboxList, setCheckboxList] = useState([]);

  let temp = list;

  useEffect(() => {
    let listTemp = data.item.split(",");
    setCheckboxList(listTemp);
  }, [data]);

  return (
    <>
      <div
        style={{
          marginBottom: 25,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: isMobile ? 10 : 11,
          }}
        >
          <PretendardText
            style={{
              color: "#2F3941",
              fontSize: "16px",
              fontWeight: 600,
              lineHeight: "23.2px",
            }}
          >
            {data.title}
          </PretendardText>
          {data.isRequired ? (
            <PretendardText
              style={{
                color: "#00AEEF",
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "23.2px",
              }}
            >
              *
            </PretendardText>
          ) : null}
        </div>

        {checkboxList.length > 0
          ? checkboxList.map((item, index) => {
              return (
                <RightLabelCheckbox
                  key={index}
                  inputStyle={{
                    marginBottom: checkboxList.length === index + 1 ? 0 : 12,
                  }}
                  text={item}
                  checked={checkboxValue.some((item02) => item02 === item)}
                  onChange={() => {
                    let tempList;
                    if (checkboxValue.some((item02) => item02 === item)) {
                      tempList = checkboxValue.filter(
                        (item03) => item03 !== item
                      );
                      setCheckboxValue(tempList);
                    } else {
                      tempList = [...checkboxValue, item];
                      setCheckboxValue(tempList);
                    }

                    let tempIndex = list.findIndex(
                      (item04) => item04.id === data.id
                    );
                    temp[tempIndex] = {
                      ...data,
                      value: JSON.stringify(tempList),
                    };

                    setList(temp);
                  }}
                />
              );
            })
          : null}
      </div>
    </>
  );
};

export default CheckboxForm;
